import { type CSSProperties } from "react";
import { useCommandPalette } from "./CommandPaletteContext";

/**
 * Sprint 3 (S3.26) — restores the visual slot Sprint 9a cleared, but this time
 * it's a real, working element: click opens the palette, and it teaches the
 * keyboard shortcut. OS-detected label (⌘K on Mac, Ctrl K elsewhere) — the hint
 * affects the label only; both shortcuts are listened to regardless.
 */
function isMac(): boolean {
  if (typeof navigator === "undefined") return false;
  const platform = navigator.platform || navigator.userAgent || "";
  return /Mac|iPhone|iPad|iPod/i.test(platform);
}

export function CmdKHint() {
  const { setOpen } = useCommandPalette();
  const label = isMac() ? "⌘K" : "Ctrl K";

  return (
    <button
      onClick={() => setOpen(true)}
      title="Search and run commands (⌘K)"
      aria-label="Open command palette"
      style={hint}
    >
      <i className="ti ti-search" style={{ fontSize: 13, color: "var(--color-text-tertiary)" }} aria-hidden="true" />
      <span style={kbdLabel}>{label}</span>
    </button>
  );
}

const hint: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  height: 28,
  padding: "0 8px",
  border: "var(--kuvio-border-default)",
  borderRadius: "var(--border-radius-md)",
  background: "var(--color-background-secondary)",
  color: "var(--color-text-tertiary)",
  cursor: "pointer",
  fontFamily: "var(--font-sans)",
};

const kbdLabel: CSSProperties = {
  fontSize: 11,
  fontWeight: 500,
  color: "var(--color-text-secondary)",
  fontVariantNumeric: "tabular-nums",
};
